import { render, staticRenderFns } from "./CampaignsAdsGridHeadline.vue?vue&type=template&id=35876bd4"
import script from "./CampaignsAdsGridHeadline.vue?vue&type=script&lang=ts"
export * from "./CampaignsAdsGridHeadline.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsAdsGridHeadline.vue?vue&type=style&index=0&id=35876bd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports